export default "__VITE_ASSET__OUZoo9OU__"